import ManageStreetCredsAdmin from 'src/pages/Admin/streetcred/StreetCreds';
import AddBehaviour from 'src/pages/Admin/streetcred/addbehaviour';

export const StreetCred = ManageStreetCredsAdmin;
export { ManageStreetCredsAdmin, AddBehaviour };
export default StreetCred;
